import { createApi } from "@reduxjs/toolkit/query/react";

import { getDynamicApiUrl } from "utils/api-config.util";
import { baseQueryWithReauthFn } from "utils/services.util";

export const API_TAGS = [
  "AccountsReceivableReport",
  "Adjustments",
  "AdjustmentsQuickBooksSync",
  "Audiometers",
  "AppointmentCompletionReport",
  "AppointmentCounters",
  "AppointmentOutcomeReasons",
  "AppointmentStatuses",
  "AppointmentStatusesByReferralSource",
  "AppointmentCreatedByReferralSource",
  "AppointmentTimer",
  "AppointmentTypes",
  "Appointments",
  "AssignedAppointmentTags",
  "AssignedPatientTags",
  "AssignedPatientProductTags",
  "AssignedSaleTags",
  "AssignedPatientChartNoteTags",
  "AssignedTouchpoints",
  "BulkTouchpoints",
  "TouchpointsPreview",
  "AudiometerConfigurations",
  "ChartNoteCounts",
  "ChartNotes",
  "CommissionsReport",
  "CPTCodes",
  "Credits",
  "ClaimsReport",
  "Clinics",
  "ClinicVideos",
  "PatientTags",
  "PatientPortalVideos",
  "ClinicCampaigns",
  "CustomFilterViews",
  "CustomTests",
  "Dashboards",
  "EraClaims",
  "Paginated-EraClaims",
  "Events",
  "ProductsAccounts",
  "FormTemplates",
  "Notifications",
  "NotificationUnreadCounts",
  "HCFA1500Forms",
  "ICD10Codes",
  "Invoices",
  "IntakeForms",
  "IntakeFormSubmissionsReport",
  "InsurerCptCodes",
  "PatientCptCodes",
  "Insurers",
  "InsurancePolicies",
  "InsurerReceivables",
  "InventoryBundle",
  "InventoryBundles",
  "InventoryProducts",
  "InventoryProductDetail",
  "InventoryProductCounters",
  "Invites",
  "Faxes",
  "FaxesCount",
  "ManagedCarePlans",
  "ManagedCareProviders",
  "ManagedCareReceivables",
  "MarketplaceIntegrations",
  "MasterProducts",
  "Manufacturers",
  "PracticeManufacturers",
  "MergeTagsPatient",
  "MergeTagsReport",
  "MergeTagsSale",
  "MergeTagsAppointment",
  "MergeTagsPatientProduct",
  "Messages",
  "AssignedDialogsCount",
  "MessageTemplates",
  "PracticeMarketplaceIntegrations",
  "NoahEventSubscriptions",
  "NoahPatient",
  "NoahSessions",
  "NoahDevices",
  "Orders",
  "OrderItems",
  "OnboardingFormRequest",
  "PatientTags",
  "Patient",
  "Patients",
  "Payments",
  "PaymentsQuickBooksSync",
  "PaymentsBreakdown",
  "PatientStaffTasks",
  "PatientNotes",
  "Physicians",
  "PatientDocuments",
  "PatientPortalAudiologyReports",
  "PatientPortalDocuments",
  "EDocuments",
  "Products",
  "PatientProducts",
  "PatientProductsCounters",
  "PatientProductsWithAssignedTags",
  "PatientDialogs",
  "PatientFakeDialogs",
  "PatientQuickBooksDetails",
  "PatientSummary",
  "PriceTables",
  "PriceTableItems",
  "PriorAuthorizationCodes",
  "ProductsRequests",
  "PodiumToken",
  "PodiumDirectory",
  "PodiumClinicMappings",
  "PodiumUserMappings",
  "QuickBooksTokens",
  "QuickBooksProducts",
  "QuickBooksCompanies",
  "QuickBooksProductsRelations",
  "QuickBooksDefaultMappings",
  "QuickBooksAdjustmentTypesMappings",
  "QuickBooksAccounts",
  "QuickBooksRefundAccounts",
  "QuickBooksTaxProducts",
  "QuickBooksSyncExceptions",
  "QuickBooksClassMappings",
  "QuickBooksDashboard",
  "Rooms",
  "Refunds Report",
  "Sales Refunds",
  "ReferralSourceChildren",
  "ReferralSources",
  "RefundsQuickBooksSync",
  "Regions",
  "Report",
  "Reports",
  "Surveys",
  "Schedule",
  "SearchProducts",
  "Sales",
  "SalesQuickBooksSync",
  "Paginated-Sales",
  "SaleItemCosts",
  "SaleItems",
  "SalesTaxes",
  "GeneralLedger",
  "StaffAvailability",
  "ScheduledEvents",
  "StaffTasks",
  "StaffTasksCount",
  "StaffTaskAttachments",
  "Staff",
  "StaffMetrics",
  "StaffNetPayments",
  "Statements",
  "SubReferralSources",
  "Tags",
  "TagActionTemplates",
  "TemplateCategories",
  "Touchpoints",
  "TextTemplates",
  "UnreadMessagesCount",
  "Users",
  "Vendors",
  "WeeklySchedule",
  "WordLists",
  "PaymentRequests",
  "ClinicTaxes",
  "DiscountTypes",
  "Form",
  "ReportAttachments",
  "AiInsights",
  "AiSalesForecastBands",
  "SurveyReports",
  "RoomTraffic",
  "SalesManagement",
  "SalesManagementAppointmentTypes",
  "SalesByZipCode",
  "SalesByAppointmentType",
  "MigrationRecords",
  "VisitTrackers",
  "VisitTrackerReport",
  "VisitTrackersAppointments",
  "Prompt",
  "AmbientScribes",
  "AmbientScribeFeedback",
  "AmbientScribeTemplates",
  "AmbientScribeProcessingEvents",
  "AmbientScribeSessions",
  "AmbientScribeAudioChunks",
  "GoogleCalendars",
  "GoogleCredentials",
  "SendbirdUsers",
  "PatientAlerts",
  "AlertsReport",
  "PaywallFeatures",
  "PaywallLicenses",
  "PaywallUserFeatures",
  "PaywallUserSubscriptions",
  "PaywallFeatureSubscriptions",
  "Collections",
  "CollectionOutreach",
  "CollectionDisputes",
  "CollectionPaymentPlans",
  "CollectionCadenceTemplates",
  "CollectionBilling",
  "VobListing",
  "BulkActions",
  "CommsSetup",
  "ZoomConnection",
  "ReferralSourceRules",
  "AppointmentTypeChecklistItems",
  "ActiveVisitChecklists",
  "AppointmentChecklist",
  "StaffRegions",
  "StaffLicenseDefaults",
  "GoogleReviews",
  "GoogleReviewConnections",
  "GoogleReviewSummary",
  "ClinicStaffSchedule",
  "DashboardWidgets",
  "DashboardWidgetConfigs",
  "DashboardWidgetRegistry"
] as const;

export const emptySplitApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauthFn(getDynamicApiUrl),
  tagTypes: API_TAGS,
  endpoints: () => ({})
});
